<div class="rq-editor">
    <div cdkDropList (cdkDropListDropped)="drop($event)">
        <div *ngFor="let q of questions; let qi = index; trackBy: trackByIndex" cdkDrag class="border rounded p-2 mb-3">
            <div class="d-flex align-items-center mb-2">
                <span class="drag-handle mr-2" cdkDragHandle title="Drag to reorder">&#8942;&#8942;</span>
                <input class="form-control form-control-sm font-weight-bold"
                       [(ngModel)]="q.label" (ngModelChange)="changed()"
                       [ngModelOptions]="{standalone: true}"
                       placeholder="Question (e.g. Meal preference)">
                <button type="button" class="btn btn-sm btn-outline-danger ml-2" title="Remove question"
                        (click)="removeQuestion(qi)">
                    <i class="uil uil-times"></i>
                </button>
            </div>

            <div class="d-flex flex-wrap align-items-center mb-2">
                <select class="form-control form-control-sm mr-3 w-auto"
                        [(ngModel)]="q.type" (ngModelChange)="changed()"
                        [ngModelOptions]="{standalone: true}"
                        aria-label="Answer type">
                    <option value="SINGLE_SELECT">One answer (radio buttons)</option>
                    <option value="MULTI_SELECT">Several answers (checkboxes)</option>
                </select>
                <div class="form-check">
                    <input type="checkbox" class="form-check-input"
                           [id]="idPrefix + 'Req' + qi"
                           [(ngModel)]="q.required" (ngModelChange)="changed()"
                           [ngModelOptions]="{standalone: true}">
                    <label class="form-check-label" [for]="idPrefix + 'Req' + qi">Required</label>
                </div>
            </div>

            <div *ngFor="let opt of q.options; let oi = index" class="d-flex align-items-center mb-1">
                <span class="text-muted mr-2" aria-hidden="true">{{ q.type === 'MULTI_SELECT' ? '☐' : '○' }}</span>
                <input class="form-control form-control-sm"
                       [(ngModel)]="opt.label" (ngModelChange)="changed()"
                       [ngModelOptions]="{standalone: true}"
                       placeholder="Option {{ oi + 1 }}">
                <button type="button" class="btn btn-sm btn-danger ml-2" title="Remove option"
                        [disabled]="q.options.length <= 1"
                        (click)="removeOption(q, oi)">
                    <i class="uil uil-times"></i>
                </button>
            </div>
            <button type="button" class="btn btn-sm btn-outline-secondary mt-1"
                    [disabled]="q.options.length >= maxOptions"
                    (click)="addOption(q)">
                <i class="uil uil-plus"></i> Add Option
            </button>
        </div>
    </div>
    <button type="button" class="btn btn-sm btn-secondary mt-1"
            [disabled]="questions.length >= maxQuestions"
            (click)="addQuestion()">
        <i class="uil uil-plus"></i> Add Question
    </button>
</div>
